import { useTranslation } from "react-i18next";
import { WEB_CONFIRMATION_EXP } from "settings";
import { useExperimentValues } from "hooks/experiments/use-experiment-values";
import {
  AppStoresQrCodeB,
  AppStoresQrCodeC,
  ContainerExp,
  Title,
  Description,
} from "./styles";

export function QrCode() {
  const { t } = useTranslation("screens", {
    keyPrefix: "confirmation.download",
  });

  const webExpValues = useExperimentValues(WEB_CONFIRMATION_EXP);

  const isBulleted = webExpValues?.value.bulleted as boolean;

  return (
    <ContainerExp>
      {isBulleted ? <AppStoresQrCodeB /> : <AppStoresQrCodeC />}
      <div>
        <Title>{t("qrCodeTitle")}</Title>
        <Description>{t("qrCodeDesc")}</Description>
      </div>
    </ContainerExp>
  );
}
